export class Wallet {
  cup: number = 0;
  usd: number = 0;
  eur: number = 0;

  add(type: 'CUP' | 'USD' | 'EUR', amount: number): void {
    const key = type.toLowerCase() as 'cup' | 'usd' | 'eur';
    (this as any)[key] += amount;
  }

  valueInCup(): number {
    return this.cup + this.usd * 500 + this.eur * 600;
  }

  get(type: 'CUP' | 'USD' | 'EUR'): number {
    const key = type.toLowerCase() as 'cup' | 'usd' | 'eur';
    return (this as any)[key];
  }

  reset(): void {
    this.cup = 0;
    this.usd = 0;
    this.eur = 0;
  }
}

export const CURRENCY_RATES = { CUP: 1, USD: 500, EUR: 600 } as const;
export type IWallet = Wallet;
export type Currency = 'CUP' | 'USD' | 'EUR';
